import { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { RootDispatch } from 'storage/store';

interface IDecodedToken {
  sub: string;
  impersonator: string;
  callbackurl: string;
}

const useImpersonation = () => {
  const [impersonatorDetails, setImpersonatorDetails] = useState<{
    impersonator?: string;
    callbackurl?: string;
  }>({});
  const dispatch = useDispatch<RootDispatch>();
  const token = localStorage.getItem('token');
  useEffect(() => {
    if (!token) {
      return;
    }
    const { impersonator, callbackurl }: IDecodedToken = jwtDecode(token);
    if (impersonator) {
      dispatch.user.setImpersonation(true);
      setImpersonatorDetails({ impersonator, callbackurl });
    }
  }, [token]);
  return impersonatorDetails;
};

export default useImpersonation;
